// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__4LCbF","rootSmall":"AddTileButton_rootSmall__3b7NV"};